import { render, staticRenderFns } from "./AnxLogin.vue?vue&type=template&id=5cbdd526&scoped=true&"
import script from "./AnxLogin.vue?vue&type=script&lang=ts&"
export * from "./AnxLogin.vue?vue&type=script&lang=ts&"
import style0 from "./AnxLogin.vue?vue&type=style&index=0&id=5cbdd526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbdd526",
  null
  
)

export default component.exports